export const HEADER = 'Travel Program';

export const DESCRIPTION =
	"Simplify the process for employees to expense rides directly through the Xpress app. Additionally, gain valuable insights into your team's transportation expenditure.";

export const KEY_BENEFITS = [
	'Set usage and spending limits',
	'Available in Metro Manila',
	'24/7 online support',
];

export const QUESTIONS = 'Questions';

export const FAQS = [
	{
		question: 'How do payment and billing work?',
		answer: "When enrolling in an Xpress for Business account, you'll need to link a payment method—such as a credit card—to your business profile. Charges for your employees’ Xpress trips or Xpress Eats meals will be processed through this payment method upon completion. Eligible organizations can opt for monthly billing arrangements, facilitating payments through credit card or bank transfer.Account administrators receive comprehensive payment statements and reports, enabling seamless tracking of all activities on the business account.",
	},
	{
		question: 'How can I set a budget in order to limit total spend?',
		answer: 'Account administrators have the ability to establish spending limits for employees’ business travel and meals. These limits can be configured on a per trip or per meal basis, as well as on a daily, monthly, or weekly basis for meal programs.',
	},
	{
		question: 'How can I add an employee to a Travel or Meal program?',
		answer: 'Employees can be assigned to designated groups within the Xpress for Business dashboard, tailored to their specific service needs. These groups serve as a method to categorize individuals within your organization based on their usage patterns and requirements with Xpress.',
	},
];
